import React from 'react';
// Components
import DominationForm from '../forms/DominationForm';
import { CONTACT_PAGE_URL } from '../../utils/Routes';
import { Link } from 'react-router-dom';

function DominatrixFormMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-12'>
      {/* Form section */}
      <section className='grid w-full'>
        <div className='grid w-full gap-y-12 px-6 lg:container lg:mx-auto pt-12'>
          {/* Intro Text */}
          <div className='max-w-3xl mx-auto text-sm lg:text-base leading-relaxed space-y-4 text-center'>
            <p className='text-lg lg:text-2xl font-bold text-colour6'>
              Think you're worthy of serving Mistress Maria?
            </p>
            <p>
              I offer more than just domination — I offer complete surrender.
              Whether you crave strict discipline, elegant control, public
              humiliation, or total transformation, you’ll find yourself utterly
              undone under my gaze.
            </p>
            <p>
              I train submissives, sissies, slaves, and maids to serve with
              purpose and obedience. Sessions may include bondage, corporal
              punishment, sissy tasks, maid duties, restraint play, or even
              sensual humiliation — all tailored to break down your ego and
              rebuild you as something far more pleasing.
            </p>
            <p>
              I expect respect, honesty, and dedication from those who wish to
              serve. Fill in the application form below, and if I find you
              suitable... I may grant you the privilege of kneeling before me.
            </p>
          </div>

          {/* Form */}
          <DominationForm />
        </div>
      </section>

      {/* Tribute Rates Section */}
      <section className='grid w-full px-6 pt-12'>
        <div className='grid px-8 mx-auto py-8 gap-y-4 w-full min-w-xl max-w-3xl text-center text-colour2'>
          <h3 className='text-4xl lg:text-5xl font-titleFont text-colour6 font-semibold'>
            Tribute Rates
          </h3>
          <p className='text-sm lg:text-base leading-relaxed'>
            Sessions start from just <strong>£175</strong>. Tribute rates vary
            depending on the type, length, and intensity of the session, as well
            as any special requests.
          </p>
          <p className='text-sm lg:text-base leading-relaxed'>
            Contact me directly to discuss your ideal session and receive a
            personalized quote.
          </p>
          <div className='grid w-fit mx-auto mt-4'>
            <Link
              title='Contact me link'
              href={CONTACT_PAGE_URL}
              className='bg-colour6 hover:brightness-110 text-colour1 text-sm font-serif px-6 py-2 border-2 border-colour2 uppercase'
              aria-label='Enquire about tribute rates with Mistress Maria'
            >
              Contact Me
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default DominatrixFormMainContainer;
